import React, { useEffect, useState, useCallback } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Promotions from "../components/Promotions";
import Footer from "../components/Footer";
import Reviews from "../components/Reviews";
import BookingForm from "../components/BookingForm";
import api from "../lib/api";

export default function Landing() {
  const [services, setServices] = useState([]);
  const [open, setOpen] = useState(false);
  const [preselect, setPreselect] = useState(null);

  const loadServices = useCallback(async () => {
    try {
      const { data } = await api.get("/services");
      setServices(data);
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadServices();
  }, [loadServices]);

  const handleBookService = (svc) => {
    setPreselect(svc);
    setOpen(true);
  };

  const handleBookGeneric = () => {
    setPreselect(null);
    setOpen(true);
    setTimeout(() => {
      document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="landing-page">
      <Header onBookClick={handleBookGeneric} />
      <Hero onBookClick={handleBookGeneric} />
      <Services services={services} onBookService={handleBookService} />
      <Gallery />
      <Promotions services={services} onBookService={handleBookService} />

      <section id="booking" className="py-20 border-t border-white/5">
        <div className="max-w-4xl mx-auto px-6 md:px-12 text-center">
          <div className="eyebrow mb-4">Ready When You Are</div>
          <h2 className="font-display text-4xl sm:text-5xl text-white leading-tight">
            Your moment of <span className="italic text-[#FF2079]">glow</span> awaits.
          </h2>
          <p className="mt-4 text-[#A09CA3] max-w-xl mx-auto">
            Reservations are confirmed via phone within 2 hours. Walk-ins
            welcome based on availability.
          </p>
          <button
            data-testid="footer-book-btn"
            onClick={handleBookGeneric}
            className="pink-glow-btn mt-8 inline-flex items-center justify-center bg-[#FF2079] hover:bg-[#D91666] text-white rounded-sm h-12 px-10 text-[11px] tracking-[0.28em] uppercase transition-all"
          >
            Reserve Now
          </button>
        </div>
      </section>

      <Reviews />
      <Footer />

      <BookingForm
        open={open}
        onClose={() => setOpen(false)}
        services={services}
        preselectedService={preselect}
      />
    </div>
  );
}
